module.exports = __webpack_public_path__ + "32da6beeed46ccf322f3e38f2a17cdc6.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-320.webp.png
// module id = 362
// module chunks = 0